import request from '@/utils/request'

export function selectTeacherList(params) {
  return request({
    url: '/api/v1.0/teacher/list',
    method: 'get',
    params:params
  })
}

export function selectAllTeacher() {
  return request({
    url: '/api/v1.0/teacher/list/all',
    method: 'get',
    params:{}
  })
}

export function selectOneTeacher(tno) {
  return request({
    url: '/api/v1.0/teacher/select',
    method: 'get',
    params:{tno:tno}
  })
}

export function addTeacher(data) {
  return request({
    url: '/api/v1.0/teacher/add',
    method: 'post',
    data: data
  })
}

export function updateTeacher(data) {
  return request({
    url: '/api/v1.0/teacher/update',
    method: 'post',
    data: data
  })
}

export function deleteTeacher(data) {
  return request({
    url: '/api/v1.0/teacher/delete',
    method: 'delete',
    data: data
  })
}

// export function deleteOneTeacher(params) {
//   return request({
//     url: '/deleteTeacherByNo',
//     method: 'get',
//     params: params
//   })
// }

// export function deleteMultiTeacher(data) {
//   return request({
//     url: '/deleteMultipleTeacher',
//     method: 'post',
//     data: data
//   })
// }

